/** Bloom Bunny — the star of the experience. Moods: idle | happy | thinking | celebrating. */
export function Bunny({ size = 180, mood = "idle", className }) {
  const happy = mood === "happy" || mood === "celebrating";
  const thinking = mood === "thinking";

  return (
    <svg width={size} height={size * (250 / 220)} viewBox="0 0 220 250" className={className} aria-hidden focusable="false">
      {/* sparkles when celebrating */}
      {mood === "celebrating" && (
        <g>
          <path d="M30 60 l3 8 8 3 -8 3 -3 8 -3 -8 -8 -3 8 -3z" className="fill-secondary" />
          <path d="M188 80 l2.5 7 7 2.5 -7 2.5 -2.5 7 -2.5 -7 -7 -2.5 7 -2.5z" className="fill-teal" />
          <circle cx="180" cy="40" r="4" className="fill-primary" />
        </g>
      )}

      {/* ears */}
      <g transform={thinking ? "rotate(12 150 70)" : ""}>
        <ellipse cx="150" cy="62" rx="17" ry="50" fill="#FFF6EE" stroke="#F0E0D2" strokeWidth="3" />
        <ellipse cx="150" cy="64" rx="8" ry="34" fill="#FFC9D6" />
      </g>
      <ellipse cx="92" cy="58" rx="17" ry="50" fill="#FFF6EE" stroke="#F0E0D2" strokeWidth="3" />
      <ellipse cx="92" cy="60" rx="8" ry="34" fill="#FFC9D6" />

      {/* body + feet */}
      <ellipse cx="112" cy="208" rx="78" ry="42" fill="#FFF6EE" stroke="#F0E0D2" strokeWidth="3" />
      <ellipse cx="82" cy="242" rx="20" ry="11" fill="#FFF6EE" stroke="#F0E0D2" strokeWidth="3" />
      <ellipse cx="142" cy="242" rx="20" ry="11" fill="#FFF6EE" stroke="#F0E0D2" strokeWidth="3" />

      {/* head */}
      <circle cx="112" cy="150" r="66" fill="#FFF6EE" stroke="#F0E0D2" strokeWidth="3" />

      {/* blush */}
      <ellipse cx="78" cy="162" rx="12" ry="8" fill="#FFB3C1" opacity="0.85" />
      <ellipse cx="146" cy="162" rx="12" ry="8" fill="#FFB3C1" opacity="0.85" />

      {/* eyes */}
      {happy ? (
        <>
          <path d="M76 150 Q88 138 100 150" stroke="#2B2D42" strokeWidth="6" strokeLinecap="round" fill="none" />
          <path d="M124 150 Q136 138 148 150" stroke="#2B2D42" strokeWidth="6" strokeLinecap="round" fill="none" />
        </>
      ) : (
        <>
          {thinking && <path d="M74 132 Q88 126 100 133" stroke="#2B2D42" strokeWidth="4" strokeLinecap="round" fill="none" />}
          <ellipse cx="88" cy={thinking ? 148 : 150} rx="9" ry="12" fill="#2B2D42" />
          <ellipse cx="136" cy={thinking ? 148 : 150} rx="9" ry="12" fill="#2B2D42" />
          <circle cx="91" cy={thinking ? 144 : 146} r="3" fill="#FFFFFF" />
          <circle cx="139" cy={thinking ? 144 : 146} r="3" fill="#FFFFFF" />
        </>
      )}

      {/* nose */}
      <path d="M104 158 L120 158 L112 167 Z" fill="#FF8FA3" />

      {/* mouth */}
      {mood === "celebrating" ? (
        <path d="M98 172 Q112 192 126 172 Q112 182 98 172 Z" fill="#2B2D42" />
      ) : happy ? (
        <path d="M100 173 Q112 186 124 173 Q112 181 100 173 Z" fill="#2B2D42" />
      ) : thinking ? (
        <path d="M104 178 Q112 173 120 180" stroke="#2B2D42" strokeWidth="4" strokeLinecap="round" fill="none" />
      ) : (
        <>
          <path d="M112 167 V173" stroke="#2B2D42" strokeWidth="3.5" strokeLinecap="round" />
          <path d="M112 173 Q105 180 99 175" stroke="#2B2D42" strokeWidth="3.5" strokeLinecap="round" fill="none" />
          <path d="M112 173 Q119 180 125 175" stroke="#2B2D42" strokeWidth="3.5" strokeLinecap="round" fill="none" />
        </>
      )}

      {/* whiskers */}
      <g stroke="#E7D5C5" strokeWidth="2.5" strokeLinecap="round">
        <path d="M62 158 L40 152" />
        <path d="M62 166 L40 168" />
        <path d="M162 158 L184 152" />
        <path d="M162 166 L184 168" />
      </g>
    </svg>
  );
}

export default Bunny;
